(function () {
  const root = document.querySelector(".tpt-landing");
  if (!root) return;
  const body = document.body;
  body.classList.add("tpt-landing-page");
  const whatsappNumber = root.dataset.whatsappNumber || "17866471640";
  const whatsappLinks = root.querySelectorAll("[data-whatsapp-link]");
  const floatButton = root.querySelector(".whatsapp-float");
  const whatsappPanel = root.querySelector(".whatsapp-panel");
  const modal = root.querySelector("#catalog-modal");
  const openCatalogButtons = root.querySelectorAll("[data-open-catalog]");
  const closeCatalogButtons = root.querySelectorAll("[data-close-catalog]");

  function buildWhatsAppUrl(message) {
    const text = encodeURIComponent(message || "Hello TOPTEN Beauty, I would like to discuss a red light therapy device project.");
    return `https://wa.me/${whatsappNumber}?text=${text}`;
  }

  whatsappLinks.forEach((link) => {
    link.href = buildWhatsAppUrl();
  });

  root.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const id = link.getAttribute("href");
      if (!id || id === "#") return;
      const target = root.querySelector(id);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  root.querySelectorAll("[data-accordion]").forEach((accordion) => {
    const triggers = accordion.querySelectorAll(".accordion__trigger");
    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        const panel = trigger.nextElementSibling;
        const isActive = trigger.classList.contains("is-active");
        triggers.forEach((item) => {
          item.classList.remove("is-active");
          if (item.nextElementSibling) item.nextElementSibling.classList.remove("is-open");
        });
        if (!isActive) {
          trigger.classList.add("is-active");
          panel.classList.add("is-open");
        }
      });
    });
  });

  root.querySelectorAll(".process-step").forEach((step) => {
    step.addEventListener("click", () => {
      root.querySelectorAll(".process-step").forEach((item) => item.classList.remove("is-current"));
      step.classList.add("is-current");
    });
  });

  root.querySelectorAll("[data-slider]").forEach((slider) => {
    const track = slider.querySelector(".testimonial-track");
    const slides = slider.querySelectorAll(".testimonial");
    const prev = slider.querySelector("[data-slider-prev]");
    const next = slider.querySelector("[data-slider-next]");
    let index = 0;

    function render() {
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle("is-active", slideIndex === index);
      });
    }

    prev.addEventListener("click", () => {
      index = (index - 1 + slides.length) % slides.length;
      render();
    });

    next.addEventListener("click", () => {
      index = (index + 1) % slides.length;
      render();
    });

    window.setInterval(() => {
      index = (index + 1) % slides.length;
      render();
    }, 5200);
  });

  if (floatButton && whatsappPanel) {
    floatButton.addEventListener("click", () => {
      const isOpen = whatsappPanel.classList.toggle("is-open");
      floatButton.setAttribute("aria-expanded", String(isOpen));
      whatsappPanel.setAttribute("aria-hidden", String(!isOpen));
    });
  }

  function openModal() {
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    body.classList.add("is-modal-open");
    const firstInput = modal.querySelector("input");
    if (firstInput) firstInput.focus();
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    body.classList.remove("is-modal-open");
  }

  openCatalogButtons.forEach((button) => button.addEventListener("click", openModal));
  closeCatalogButtons.forEach((button) => button.addEventListener("click", closeModal));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.classList.contains("is-open")) closeModal();
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  root.querySelectorAll(".reveal").forEach((item) => observer.observe(item));
})();




